import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { SF_TYPE } from "../../constant/status_constant";
import { COMPANY } from "../../constant/company_constant";
import { useSelector } from "react-redux";
//import { useSelector } from "react-redux";

const Asidebar = ({ isDisplay, setDisplay }) => {
  let user = useSelector((state) => state.authReducer.currentUser);
  //  const user = useSelector((state) => state.authReducer.currentUser);
  // State to track which dropdown is open
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [partnerLogoUrl, setPartnerLogoUrl] = useState(null);

  // Toggle function for dropdowns
  const toggleDropdown = (name) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  useEffect(() => {
    (async () => {
      if (user && user.role_id && user?.partnerLogo) {
        // const url = await getSignUrl(user.partnerLogo);
        setPartnerLogoUrl(`/dist/img/${user?.partnerLogo}`);
      }
    })();
  }, [user]);

  return (
    <div>
      {/* Main Sidebar Container */}
      <aside
        onMouseEnter={() => setDisplay(false)}
        className="main-sidebar main-sidebar-custom"
      >
        {/* Brand Logo */}
        <NavLink to={"#"} className="brand-link">
          <img
            src="../../dist/img/a-removebg-preview.png"
            alt="Logo"
            className={`brand-image ${!isDisplay ? "brandtextnot" : ""} `}
            style={{ display: "none" }}
          />
          <span className="brand-text font-weight-light">
            {/* {process.env.REACT_APP_TITLE} */}
            <img
              src={partnerLogoUrl || COMPANY.logo}
              alt={COMPANY.name}
              className=""
              style={{ width: "168px" }}
            />
          </span>
        </NavLink>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user (optional) */}

          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column nav-child-indent"
              // data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}

              <li className="nav-item">
                <NavLink to={"/dashboard"} className="nav-link" exact="true">
                  <i
                    className="nav-icon fas fa-home"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Dashboard</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to={"/search"} className="nav-link" exact="true">
                  <i
                    className="nav-icon fas fa-search"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Search</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to={"/pendingbooking"}
                  className="nav-link"
                  exact="true"
                >
                  <i
                    className="nav-icon fa-solid fa-clock"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Pending Booking</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to={"/appliancecollectedbyasc"}
                  className="nav-link"
                  exact="true"
                >
                  <i
                    className="nav-icon fa-solid fa-box-open"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Appliance Collected</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to={"/bookingonapprovalsf"}
                  className="nav-link"
                  exact="true"
                >
                  <i
                    className="nav-icon fa-solid fa-user-clock"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>On Approval Booking</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to={"/getcompletedlist"}
                  className="nav-link"
                  exact="true"
                >
                  <i
                    className="nav-icon fa-solid fa-circle-check"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Completed Booking</p>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to={"/getcancelledlist"}
                  className="nav-link"
                  exact="true"
                >
                  <i
                    className="nav-icon fa-solid fa-ban"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Cancelled Booking</p>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink to={"/spareparts"} className="nav-link" exact="true">
                  <i
                    className="nav-icon fa-solid fa-screwdriver-wrench"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Spare Parts</p>
                </NavLink>
              </li>

              <li
                className={`nav-item has-treeview ${
                  openDropdowns["reportsummary"] ? "menu-open" : ""
                }`}
              >
                <Link
                  to={"#"}
                  className="nav-link"
                  onClick={() => toggleDropdown("reportsummary")}
                >
                  <i
                    className="nav-icon fa-solid fa-chart-column"
                    style={{ fontSize: "15px" }}
                  ></i>

                  <p>
                    Reports
                    <i
                      className={`right fas fa-angle-${
                        openDropdowns["reportsummary"] ? "down" : "left"
                      }`}
                      style={{ marginLeft: "auto" }}
                    />
                  </p>
                </Link>
                <ul
                  className={`nav nav-treeview ${
                    openDropdowns["reportsummary"] ? "d-block" : "d-none"
                  }`}
                >
                  <li className="nav-item">
                    <NavLink
                      to={"/bookingsummary"}
                      className="nav-link"
                      exact="true"
                    >
                      <i
                        className="nav-icon fa-solid fa-clipboard-list"
                        style={{ fontSize: "15px" }}
                      ></i>
                      <p>Booking Summary</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={"/sparesummary"}
                      className="nav-link"
                      exact="true"
                    >
                      <i
                        className="nav-icon fa-solid fa-screwdriver-wrench"
                        style={{ fontSize: "15px" }}
                      ></i>
                      <p>Spare Summary</p>
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li
                className={`nav-item has-treeview ${
                  openDropdowns["inv "] ? "menu-open" : ""
                }`}
              >
                <Link
                  to={"#"}
                  className="nav-link"
                  onClick={() => toggleDropdown("inv")}
                >
                  <i
                    className="nav-icon fas fa-file-invoice"
                    style={{ fontSize: "15px" }}
                  />
                  <p>
                    Invoice
                    <i
                      className={`right fas fa-angle-${
                        openDropdowns["inv"] ? "down" : "left"
                      }`}
                      style={{ marginLeft: "auto" }}
                    />
                  </p>
                </Link>
                <ul
                  className={`nav nav-treeview ${
                    openDropdowns["inv"] ? "d-block" : "d-none"
                  }`}
                >
                  <li className="nav-item">
                    <NavLink to={"/customeroowinvoice"} className="nav-link">
                      <i
                        className="nav-icon fa-solid fa-file-invoice-dollar"
                        style={{ fontSize: "15px" }}
                      />
                      <p>Customer Invoice</p>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to={`/invoicesummary/${btoa(SF_TYPE)}`}
                      className="nav-link"
                      exact={true}
                    >
                      <i
                        className="nav-icon fa-solid fa-file-lines"
                        style={{ fontSize: "15px" }}
                      />
                      <p>Invoice Summary</p>
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink
                  to={"/engineerslist"}
                  className="nav-link"
                  exact="true"
                >
                  <i
                    className="nav-icon fas fa-user-doctor"
                    style={{ fontSize: "15px" }}
                  ></i>
                  <p>Engineers</p>
                </NavLink>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        <br />
        {/* /.sidebar */}
        {/* <div className="sidebar-custom"></div> */}
        {/* /.sidebar-custom */}
      </aside>
    </div>
  );
};

export default Asidebar;
